
import React from 'react'

function Entry() {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.5 1H14.8333C15.2754 1 15.6993 1.17559 16.0118 1.48816C16.3244 1.80072 16.5 2.22464 16.5 2.66667V14.3333C16.5 14.7754 16.3244 15.1993 16.0118 15.5118C15.6993 15.8244 15.2754 16 14.8333 16H11.5M7.33333 12.6667L11.5 8.5M11.5 8.5L7.33333 4.33333M11.5 8.5H1.5" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default Entry
